import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navigation/Navbar';
import UserHistory from '../components/Profile/UserHistory';
import SciFiBackground from '../components/SciFiBackground/SciFiBackground';
import PlatformPageHeader from '../components/Common/PlatformPageHeader';
import { Box, Container } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';

const History = () => {
  const { t } = useTranslation();
  
  return (
    <SciFiBackground>
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navbar />
        <Box component="main" sx={{ flex: 1, display: 'flex', py: { xs: 5, md: 8 }, px: 2 }}>
          <Container maxWidth="lg">
            <PlatformPageHeader
              icon={HistoryIcon}
              eyebrow={t('nav.history', 'Activity')}
              title={t('history.title')}
              subtitle={t('history.subtitle')}
            />
            <UserHistory />
          </Container>
        </Box>
      </Box>
    </SciFiBackground>
  );
};

export default History;
